// // ProtectedRoute.js
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ element }) => {
//     const userData = JSON.parse(localStorage.getItem("user"));

//     if (userData && userData.role === "admin") {
//         return element;
//     } else {
//         return <Navigate to="/" />;
//     }
// };

// export default ProtectedRoute;

import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, allowedRoles }) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')

    if (!user) {
        return <Navigate to="/" />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to={`/${user.role}`} />;
    }

    return element;
};

export default ProtectedRoute;
